import { render, staticRenderFns } from "./upload-docs.vue?vue&type=template&id=3cb6081c&scoped=true"
import script from "./upload-docs.vue?vue&type=script&lang=js"
export * from "./upload-docs.vue?vue&type=script&lang=js"
import style0 from "./upload-docs.vue?vue&type=style&index=0&id=3cb6081c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb6081c",
  null
  
)

export default component.exports